export default {
  nav: {
    title: 'New booking'
  },
  actions: {
    create: 'Create'
  },
  form: {
    mandatory: {
      facility: 'Facility*',
      checkin_date: 'Checkin date*',
      checkin_time: 'Checkin time*',
      name: 'Name*',
      currency: 'Currency*',
      default_currency: 'Default currency*'
    },
    status: 'Status',
    checkout_date: 'Checkout date',
    checkout_time: 'Checkout time',
    last_name: 'Last name',
    email: 'Email',
    phone_number: 'Phone number',
    birth_date: 'Date of birth',
    language: 'Language',
    gender: 'Gender',
    genders: {
      FEMALE: 'Female',
      MALE: 'Male',
      OTHER: 'Other'
    },
    profile_type: 'Profile type',
    profile_category: 'Profile category',
    balance: 'Balance',
    postpaid: 'Postpaid',
    selector_values: {
      NEW: 'New',
      NONE: 'None',
      NO_ROOM: 'No room'
    },
    room: 'Room',
    guest_type: 'Guest type',
    guest_category: 'Guest category'
  },
  sections: {
    booking_info: 'General booking info',
    booking_profile: 'Booking profile',
    other_options: 'Other options',
    booking_account: 'Booking account',
    add_currency: 'Add currency',
    guest: 'Guest',
    delete_guest: 'Delete guest',
    add_guest: 'Add guest',
    room: 'Room',
    delete_room: 'Delete room',
    add_room: 'Add room',
    room_account: 'Room account',
    guest_account: 'Guest account'
  },
  errors: {
    mandatory: 'Required field'
  },
  post: {
    success_message: 'Booking successfully created',
    error_message: 'Correct the errors'
  }
}